<script setup lang="ts">
import {
    faChevronLeft,
    faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';

interface IProps {
    imageList: string[];
    selectedImageIndex: number;
}

const { selectedImageIndex, imageList } = defineProps<IProps>();
const emit = defineEmits<{
    close: [];
}>();
const slideNumber = ref(0);
const close = () => emit('close');
const nextImage = () => {
    if (slideNumber.value < imageList.length - 1) {
        slideNumber.value++;
    }
};
const previousImage = () => {
    if (slideNumber.value > 0) {
        slideNumber.value--;
    }
};
onMounted(() => {
    slideNumber.value = selectedImageIndex;
});
defineExpose({
    close,
});
const i18n = useI18n();
</script>

<template>
    <mr-modal :title="i18n.t('Card.vehicleImage')" @close="emit('close')">
        <div class="images-container">
            <mr-button
                v-if="imageList.length > 1"
                v-show="slideNumber !== 0"
                class="arrow right"
                size="small"
                :icon-button="{
                    icon: faChevronRight,
                    color: 'white',
                }"
                @click="previousImage"
            />
            <img
                v-for="(item, index) in imageList"
                :key="index"
                :src="item"
                class="image"
                :class="{ show: index === slideNumber }"
                alt="vehicle-image"
            />
            <mr-button
                v-if="imageList.length > 1"
                v-show="slideNumber !== imageList.length - 1"
                class="arrow left"
                size="small"
                :icon-button="{
                    icon: faChevronLeft,
                    color: 'white',
                }"
                @click="nextImage"
            />
        </div>
    </mr-modal>
</template>

<style scoped lang="scss">
.images-container {
    position: relative;
    width: 100%;
    padding-top: 63%;
}

.image {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 3px;
    object-fit: contain;
    opacity: 0;
    transition: opacity 300ms;
    &.show {
        opacity: 1;
    }
}

.arrow {
    position: absolute;
    top: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    transform: translateY(-50%);
    background-color: white;
    border-radius: 50px;
    z-index: 2;
    &.left {
        left: 15px;
    }
    &.right {
        right: 15px;
    }
}
</style>
